import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ApidataService } from "src/app/services/apidata.service";
import {
  SessionVar,
  RespCode,
  RespTranCode,
  APIUrl,
  WALLET_TYPE,
} from "src/app/enums/emums";
import { ApisessionService } from "../../../services/apisession.service";
import { TransactionReq } from "../../../enums/apiRequest";
import { Router } from "@angular/router";
import { TransectionResp } from "src/app/enums/apiResponse";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "src/app/services/auth.service";
@Component({
  selector: "aditya-action",
  templateUrl: "./action.component.html",
  styleUrls: ["./action.component.css"],
})
export class ActionComponent implements OnInit {
  hostDomain: string = "";
  getloc: string = "";
  request: TransactionReq = {
    accountNo: 0,
    amount: 0,
    customerNo: "",
    geoCode: "",
    o1: "",
    o2: "",
    o3: "",
    o4: "",
    oid: 0,
    refID: "",
  };
  Confirmpayment = true;
  response: TransectionResp;
  operatorName = "";
  walletBalance = 0;
  errorMsg = "";
  AccountName = "";
  IsRechargeReq: number = 0;
  OperatorType = "Bill Amount";
  IsTran = true;
  paymentCondition: boolean = false;
  AmountToPay: number = 0;
  isButtonLoading = false;
  LoginDetail = {
    IsLoggedIn: false,
    LoginUserName: '',
    LoginUserBalance: '0',
    isBalance: false,
    isUBalance: false,
    DynamicBalance: '0',
    DynamicBalanceKey: '',
  }
  constructor(
    private cdr: ChangeDetectorRef,
    private apiData: ApidataService,
    public router: Router,
    private authService: AuthService,
    private apiSession: ApisessionService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.hostDomain = APIUrl.Domain;
    this.getData(false);
    this.getgeotag();
  }

  getgeotag() {
    navigator.geolocation.getCurrentPosition((position) => {
      this.getloc = position.coords.latitude + "," + position.coords.longitude;
    });
  }

  getData(isClick: boolean) {
    if (!this.apiData.getSessionData(SessionVar.TransactionRequest)) {
      this.apiData.gotoMenu("Prepaid.html");
    } else {
      this.request = this.apiData.getSessionData(SessionVar.TransactionRequest);
      this.operatorName = this.apiData.getOperatorName(this.request.oid);
      this.AccountName = this.apiData.getOperatorAccountName(this.request.oid);
      var optype = this.apiData.getOperatorData(this.request.oid).opType;

      if (optype == 1 || optype == 3) {
        this.OperatorType = "Recharge Amount";

      }
      this.apiSession.GetBalance().subscribe((resp) => {
        if (resp.statuscode == RespCode.Success) {
          // this.walletBalance = resp.data.balance;
          const BalanceResp = resp;

          Object.keys(WALLET_TYPE).map((key) => {
            if (!BalanceResp.data[key]) return;
            let balanceKey = "";
            if (key === "isBalance") {
              balanceKey = "balance";
            } else if (key === "isBBalance") {
              balanceKey = "bBalance";
            } else if (key === "isCBalance") {
              balanceKey = "cBalance";
            } else if (key === "isUBalance") {
              balanceKey = "uBalance";
            } else if (key === "isIDBalance") {
              balanceKey = "idBalnace";
            } else if (key === "isPacakgeBalance") {
              balanceKey = "pacakgeBalance";
            }
            const amount = BalanceResp.data[balanceKey];
            this.walletBalance = amount;
            // this.LoginDetail.DynamicBalanceKey = WALLET_TYPE[key];

            const isLoggedIn = this.authService.IsAuth();
            if (isLoggedIn) {
              let loginUserName = this.authService.getUserName();
              this.LoginDetail.LoginUserBalance = BalanceResp.data.balance.toString()
              this.LoginDetail.IsLoggedIn = isLoggedIn;
              this.LoginDetail.isBalance = BalanceResp.data.isBalance;
              this.LoginDetail.isUBalance = BalanceResp.data.isUBalance;
              this.LoginDetail.LoginUserName = loginUserName
              this.LoginDetail.DynamicBalance = amount;
              this.LoginDetail.DynamicBalanceKey = WALLET_TYPE[key];
              this.apiData.sendObjectData(this.LoginDetail)
            }
          });

          if (this.request.amount > this.walletBalance) {
            this.AmountToPay = parseFloat(
              (this.request.amount - this.walletBalance).toFixed(3)
            );
            if (this.request.amount > this.walletBalance) {
              this.Confirmpayment = false;
              this.IsRechargeReq = 1;
              if (isClick) {
                document.getElementById("btnTemo").click();
              }

              this.IsTran = false;
              this.isButtonLoading = false;

              return false;
            }
          } else {
            this.AmountToPay = 0;
          }
          this.IsTran = false;
        }
        this.isButtonLoading = false;
      });
    }
    this.IsTran = false;
    this.isButtonLoading = false;
  }
  proceedTotransaction() {
    this.request.geoCode = this.getloc;
    this.IsTran = true;
    this.paymentCondition = true;

    this.apiSession.Transaction(this.request).subscribe((resp) => {
      this.response = resp;
      if (
        this.response.statuscode == RespTranCode.Success ||
        this.response.statuscode == RespTranCode.Pending
      ) {
        this.apiData.setSessionData(
          SessionVar.TransactionResponse,
          this.response
        );
        this.router.navigate(["paymentsuccess.html"]);
      } else if (this.response.statuscode == RespTranCode.Refund) {
        this.apiData.setSessionData(
          SessionVar.TransactionResponse,
          this.response
        );
        this.router.navigate(["paymentsuccess.html"]);
      } else {
        this.errorMsg = this.response.msg;
        this.toastr.error(this.errorMsg, "Error");
      }

      this.IsTran = false;
      this.paymentCondition = false;
    });
  }

  async openAddMoney() {
    if (this.request.amount <= this.walletBalance) {
      await this.getData(false);
      this.proceedTotransaction();
    } else {
      this.isButtonLoading = true;
      this.cdr.detectChanges();
      this.getData(true);
    }
  }
}
